import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'index',
        component: () => import('@/views/home/index.vue')
    },
    {
        path: '/aboutUs',
        name: 'index',
        component: () => import('@/views/aboutUs/index.vue')
    },
    {
        path: '/solution',
        name: 'index',
        component: () => import('@/views/solution/index.vue')
    },
    {
        path: '/solutionDetail',
        name: 'index',
        component: () => import('@/views/solutionDetail/index.vue')
    },
    {
        path: '/contactUs',
        name: 'index',
        component: () => import('@/views/contactUs/index.vue')
    },
    {
        path: '/equipment',
        name: 'index',
        component: () => import('@/views/equipment/index.vue')
    },
    {
        path: '/video',
        name: 'index',
        component: () => import('@/views/video/index.vue')
    },
    {
        path: '/news',
        name: 'index',
        component: () => import('@/views/news/index.vue')
    },
    {
        path: '/newsDetail',
        name: 'index',
        component: () => import('@/views/newsDetail/index.vue')
    },
    {
        path: '/search',
        name: 'index',
        component: () => import('@/views/search/index.vue')
    }
    
    ,
    {
        path: '/seatchResult',
        name: 'index',
        component: () => import('@/views/search/searchResult.vue')
    }

    //     path: '/number',
    //     name: 'number',
    //     component: () => import('../views/number.vue')
    // }
]
const router = new VueRouter({
    routes,
    scrollBehavior(to, from, savedPosition) {  
        return { x: 0, y: 0 };  // 跳转到页面顶部  
      } 
})

export default router